export const MARCA_BLANCA_HASH_PARAM = "hash";

export const getHashFromUrl = (
  search: string = window.location.search,
): string => {
  const value = new URLSearchParams(search).get(MARCA_BLANCA_HASH_PARAM);
  return (value ?? "").trim();
};

// Quita el parámetro `hash` de la URL sin recargar ni cambiar de ruta. Se usa
// cuando el hash es inválido/expirado: así el guardia deja de tratar la URL
// como "autenticando por hash" y vuelve a redirigir al home (igual que si se
// entrara sin hash) para pedir la autenticación manual.
export const removeHashFromUrl = (): void => {
  const url = new URL(window.location.href);
  
  if (!url.searchParams.has(MARCA_BLANCA_HASH_PARAM)) return;

  url.searchParams.delete(MARCA_BLANCA_HASH_PARAM);

  const search = url.searchParams.toString();

  window.history.replaceState(
    null,
    "",
    `${url.pathname}${search ? `?${search}` : ""}${url.hash}`,
  );
};
